import { render, staticRenderFns } from "./dashboard-button-primary.vue?vue&type=template&id=17ec42dd&"
import script from "./dashboard-button-primary.vue?vue&type=script&lang=js&"
export * from "./dashboard-button-primary.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-button-primary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports